import { CommonInsightsReportHelp } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightViews";
import { CommonInsightsDeploymentDurationOverview } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonInsightsDeploymentDurationViews";
export const InsightsReportDeploymentDurationHelp = () => (<>
        <CommonInsightsDeploymentDurationOverview /> <CommonInsightsReportHelp />
    </>);
